/**
 * Hit result enum.
 */
export enum HitResultEnum {
  OK,
  PLAYER_CHANGE,
  END,
  LOST_GAME,
  LOST_GAME_ABANDOND,
  LOST_GAME_FOULS,
  WIN_GAME,
  WIN_GAME_SEVEN_BALLING,
  WIN_GAME_GOLDEN_BREAK,
  WIN_GAME_RUNOUT,
  WIN_GAME_CENTURY,
  WIN_GAME_SYNCHRONIZE_ERROR,
}
